<template>
  <div class="backgroundWhite">
    <div class="banner"></div>
    <div class="main">
      <Bread></Bread>
      <div class="title clearfix">
        <span class="title-name name1">肿瘤</span>
        <span class="title-english title-white">TUMOUR</span>
        <span class="title-note title-white">核心业务范围</span>
        <div class="title-line"></div>
      </div>
      <div class="ill-kind">
        <router-link class="ill-list"
                     v-for="(ill,index) in ills"
                     :to="ill.path">{{ill.name}}</router-link>
      </div>

      <div class="more">更多</div>
    </div>

  </div>
</template>
<script>
import Bread from '@/components/Bread.vue'
export default {
  data () {
    return {
      ills: [
        { name: '胃癌', path: '/' },
        { name: '肠癌', path: '/' },
        { name: '口腔癌', path: '/' },
        { name: '骨髓癌', path: '/' },
        { name: '乳腺癌', path: '/' },
        { name: '肺癌', path: '/' },
      ]
    }
  },
  components: {
    Bread
  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style lang="less" scope>
.backgroundWhite {
  background: #fff;
  min-height: 786px;
}
.banner {
  width: 100%;
  height: 250px;
  background: url('../assets/images/illness/banner.jpg') no-repeat center;
}
.main {
  // position: relative;
  // z-index: 9;
  width: 980px;
  margin: 0 auto;
}
.ill-kind {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.ill-list {
  display: inline-block;
  width: 308px;
  height: 100px;
  background: #414141;
  color: #fff;
  font-size: 32px;
  line-height: 100px;
  text-align: center;
  margin-bottom: 38px;
}
.ill-list:hover {
  background: #ae1e10;
  color: #fff;
}
.more {
  height: 65px;
  background: #bebebe;
  color: #fff;
  font-size: 28px;
  line-height: 65px;
  text-align: center;
}
</style>